import { render, staticRenderFns } from "./todosList.vue?vue&type=template&id=6ba00e7c&scoped=true&"
import script from "./todosList.vue?vue&type=script&lang=js&"
export * from "./todosList.vue?vue&type=script&lang=js&"
import style0 from "./todosList.vue?vue&type=style&index=0&id=6ba00e7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba00e7c",
  null
  
)

export default component.exports